import { combineReducers } from "redux"
import aspLocationsReducer from "./aspLocationsReducer"
import aspStateReducer from "./aspStateReducer";

export default combineReducers({
    aspLocations: aspLocationsReducer,
    aspState: aspStateReducer
})